import { idb } from "../db/index.ts";
import { g } from "../util/index.ts";
import { defineView } from "../util/defineView.ts";
import { customTournament } from "../core/index.ts";

export default defineView({
	id: "customTournament",
	load: async ({ updateEvents }) => {
		if (
			updateEvents.has("firstRun") ||
			updateEvents.has("gameAttributes") ||
			updateEvents.has("gameSim")
		) {
			const attribute = await idb.cache.gameAttributes.get("customTournament");
			return {
				season: g.get("season"),
				countries: await customTournament.getCountries(),
				tournament: attribute?.value,
			};
		}
	},
});
